// src/theme/atomic/red.ts
var red = {
  10: "#3B0101",
  20: "#730303",
  30: "#B00C0C",
  40: "#E52222",
  50: "#FF4242",
  60: "#FF6363",
  70: "#FF8C8C",
  80: "#FFB5B5",
  90: "#FED5D5",
  95: "#FEECEC",
  99: "#FFFAFA"
};
var red_default = red;

export { red_default as default };
